import { render } from "./VisualRuleBuilderView.vue?vue&type=template&id=651838be"
import script from "./VisualRuleBuilderView.vue?vue&type=script&lang=js"
export * from "./VisualRuleBuilderView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__